<template>
   <div class="my-5">
       <h3 class="text-info my-4">Cat's Silhouette<br><small class="text-muted border-top">Choose a Cats's Silhouette</small></h3>
       <div class="sihlouette-container rounded">
           <div class="row">
               <div class="col-md col-sm-4 col-6 p-3" v-for="cat in Cats" :key="cat.value">
                   <img @click="selectThis(cat.img_name)" 
                        class="img-fluid animal-pic" 
                        :src="'/static/img/cats/' + cat.img_name" alt="Cat's Silhouette">
                <transition name="fade">
                   <img v-show="selectedDoggy.includes(cat.value)" 
                        class="selected-animal-silhouette img-fluid animal-pic" 
                        @click="removeThis(cat.value)"
                        :src="'/static/img/cats/' + cat.img_name_selected" 
                        alt="Selected Cat">
                </transition>
               </div>
           </div>
       </div>
   </div>
 </template>
 
<script>
    import Data from '@/data/data'
    export default {
        name: 'Cats',
       data() {
           return {
               Cats: Data.cats,
               selectedDoggy: ''
           }
       },
       methods: {
           selectThis(cat) {
               this.selectedDoggy = cat;
               this.$emit('getThisCat', cat)
           },
           removeThis(cat){
                this.selectedDoggy = ''
                this.$emit('removeThisCat', cat)
           }
       }
    }
</script>




// WEBPACK FOOTER //
// src/components/JQueryPluggins/Cats.vue